import styled from 'styled-components';

import { COLORS } from '../../../utils/theme/colors';

export const CustomOption = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4px 8px;
  cursor: pointer;
  align-items: center;
  background-color: white;

  &:hover {
    background-color: #e6f7ff;
  }

  .optionText {
    color: ${COLORS.black};
  }

  .actions {
    visibility: hidden;
  }

  &:hover .actions {
    visibility: visible;
  }
`;
